var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { observable, when } from 'mobx';
import { merge } from 'lodash';
var s3ProfilesRoot = 'https://atlas.collegeboard.org/widgets/profiles';
var s3PermissionsRoot = 'https://atlas.collegeboard.org/widgets/settings/permissions.json';
var defaultPermissions = {
    assumedAppId: false
};
var DeploymentProfileStore = /** @class */ (function () {
    function DeploymentProfileStore() {
        var _this = this;
        this.loaded = false;
        this.fetchPermissionsProfile = function () { return __awaiter(_this, void 0, void 0, function () {
            var permissions, pRes, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        permissions = { assumedAppId: false };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios.get(s3PermissionsRoot)];
                    case 2:
                        pRes = _a.sent();
                        permissions = pRes.data;
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, permissions];
                }
            });
        }); };
        this.fetchDeploymentProfile = function () { return __awaiter(_this, void 0, void 0, function () {
            var permissions, dp, appId, pRes, dpRes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        permissions = merge({}, defaultPermissions);
                        dp = window.cb.core.utils.DeploymentProfile;
                        appId = this.appId;
                        if (!dp.iam) return [3 /*break*/, 2];
                        if (!dp.iam.appId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fetchPermissionsProfile()];
                    case 1:
                        pRes = _a.sent();
                        permissions = merge(permissions, pRes[dp.iam.appId]);
                        _a.label = 2;
                    case 2:
                        if (permissions.assumedAppId) {
                            appId = dp.iam.appId;
                        }
                        return [4 /*yield*/, axios.get(s3ProfilesRoot + "/" + appId + ".json")];
                    case 3:
                        dpRes = _a.sent();
                        this.dp = dpRes.data;
                        this.loaded = true;
                        return [2 /*return*/];
                }
            });
        }); };
        when(function () { return !!_this.appId; }, this.fetchDeploymentProfile);
    }
    __decorate([
        observable
    ], DeploymentProfileStore.prototype, "appId", void 0);
    __decorate([
        observable
    ], DeploymentProfileStore.prototype, "dp", void 0);
    __decorate([
        observable
    ], DeploymentProfileStore.prototype, "loaded", void 0);
    return DeploymentProfileStore;
}());
export var dpStore = new DeploymentProfileStore();
